module.exports = __webpack_public_path__ + "static/ni-32e4d1fec5a0735fb7c18ddcbb9c2f64.svg";